export default "__VITE_ASSET__iwTOy_9$__"